import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MusicBars from "../../../../components/animation/MusicBars";
import GradientPrimary from "../../../../components/gradient/GradientPrimary";
import dojaCat1 from "../../../../media/images/doja-cat1.jpg";
import { playNewSong, setplay } from "../../../../redux/actions/player";
import { mainPlayerToggle } from "../../../../redux/actions/styles";
import { topSongsData } from "../../../Explore/TopSongs/topSongsData";
import PlaylistAddRoundedIcon from "@mui/icons-material/PlaylistAddRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import { setselectedAddPlaylist } from "../../../../redux/actions/music";
import TooltipPrimary from "../../../../components/tooltips/TooltipPrimary";

const Popular = () => {
  const dispatch = useDispatch();
  const { currentSong, play } = useSelector((state) => state.player);

  function onClickPlay(song) {
    dispatch(playNewSong(song));
    dispatch(setplay(true));
    dispatch(mainPlayerToggle(true));
  }
  return (
    <div className="popular">
      <GradientPrimary />
      <div className="header">
        <div className="col">
          <h3>Name</h3>
        </div>
        <div className="col">
          <h3>Album</h3>
        </div>
        <div className="col">
          <h3>Plays</h3>
        </div>
        <div className="col">
          <h3>Actions</h3>
        </div>
      </div>
      <div className="songs">
        {topSongsData.map((item) => (
          <div key={item.name + item.artist} className="card">
            <div className="left">
              <img src={item.img} alt="justin bieber" />
              <div className="details">
                <h3>{item.name}</h3>
                <p className="artist">{item.artist}</p>
                <p className="time">{item.duration}</p>
              </div>
            </div>
            <div className="album">
              <p>Planet Her · 2021</p>
            </div>
            <div className="plays">
              <p>26,790,80 plays</p>
            </div>
            <div className="actions">
              {play && currentSong.name === item.name ? <MusicBars /> : null}

              {play && currentSong.name === item.name ? (
                <TooltipPrimary text="Pause" className="icon pause-btn" onClick={() => dispatch(setplay(false))}>
                  <PauseRoundedIcon />
                </TooltipPrimary>
              ) : (
                <TooltipPrimary text="Play" className="icon play-btn" onClick={() => onClickPlay(item)}>
                  <PlayArrowRoundedIcon />
                </TooltipPrimary>
              )}
              <TooltipPrimary
                text="Add to playlist"
                className="icon playlist"
                onClick={() => dispatch(setselectedAddPlaylist(item))}
              >
                <PlaylistAddRoundedIcon />
              </TooltipPrimary>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Popular;
